import * as React from "react";

function SvgLoadPort(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 34 34" fill="none" {...props}>
      <path
        d="M0 7.727v4.637h34V7.727H0zM6.182 24.727L17 13.91l10.818 10.818h-7.727V34h-6.182v-9.273H6.182zM1.545 6.182h30.91L26.273 0H7.727L1.545 6.182z"
        fill="#fff"
      />
    </svg>
  );
}

export default SvgLoadPort;
